import React, {Component} from 'react';
import {connect} from 'react-redux';
import store from 'store';

import {
    CardHeader,
    Card, CardBody
} from 'reactstrap';
import {Field, reduxForm} from 'redux-form';
import {handleResendCode, handleVerifyPhone} from "../tenant/actions/tenant";
import {InputField} from "../../validation/ReduxFormInput";
import {AsyncButton, FormAsyncButton} from "../../components/controls/buttons/AsyncButton";

class ConfirmPhone extends Component {
    render() {
        const {phone_verified, phone, handleSubmit, _handleVerifyPhone, submitting, pristine, invalid} = this.props;

        if (store.get('type') === 'tenant' && phone && !phone_verified) return (
            <Card outline color="danger" className="pr-card">
                <CardHeader tag="h4">Confirm Your Phone Number</CardHeader>
                <CardBody>
                    <form onSubmit={handleSubmit(_handleVerifyPhone)}>
                        <p className="mb-2">A verification code was sent to {phone} - please enter it below</p>
                        <Field name="code" placeholder="Code" component={InputField}/>
                        <FormAsyncButton acting={submitting} type="submit" color="success" disabled={pristine || invalid}>Verify</FormAsyncButton>
                        <AsyncButton task={() => this.props._handleResendCode()} noComplete color="primary" style={{marginLeft: '1em'}} outline>Resend Text</AsyncButton>
                    </form>
                </CardBody>
            </Card>
        );
        else return null;
    }
}

const validate = (values) => {
    const errors = {};

    !values.code && (errors.code = 'Required');

    return errors;
};

const mapStateToProps = (state) => ({
    phone_verified: state.tenant.phone_verified,
    phone: state.activeUser.phone
});

const mapDispatchToProps = (dispatch) => ({
    _handleVerifyPhone(data) {
        return dispatch(handleVerifyPhone(data));
    },
    _handleResendCode() {
        return dispatch(handleResendCode());
    }
});

ConfirmPhone = reduxForm({
    form: 'verify_phone',
    validate
})(ConfirmPhone);

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmPhone);


// WEBPACK FOOTER //
// ./src/containers/settings/ConfirmPhone.js